<ng-template #template>
  <md-wrap-loader data-test="Y1tuZnHw" [show]="showLoader" [hideContent]="true">
    <div
      data-test="UEoega8b"
      mat-dialog-content
      style="overflow-y: auto; max-height: 100vh !important; margin: 0; padding: 0"
    >
      <div data-test="_OPQmxVL" class="md-modal-title">
        <span
          data-test="niQX0eMa"
          class="badge badge_gray md-modal-close-icon"
          (click)="close()"
        >
          <i data-test="kW2yGMpj" class="material-icons md-12">close</i>
        </span>
        <div data-test="Sr20G6It" class="md-modal-title-inner">
          <div data-test="69t84UnZ" #titleRef>
            <ng-content select="md-modal-title"></ng-content>
          </div>
          <ng-container *ngIf="!titleRef.innerHTML.trim()">
            <h2 data-test="z8S6Zg0f" class="text-center">
              {{ title }}
            </h2>
          </ng-container>
        </div>
      </div>
      <div data-test="lp6LT-fV" class="md-modal-content">
        <div data-test="iQ41q9HG" #contentRef>
          <ng-content select="md-modal-content"></ng-content>
        </div>
        <ng-container *ngIf="!contentRef.innerHTML.trim()">
          {{ content }}
        </ng-container>
      </div>
      <div data-test="d5pRcVni" class="md-modal-actions" *ngIf="!hideActions">
        <div data-test="8WnNMug7" #actionsRef>
          <ng-content select="md-modal-actions"></ng-content>
        </div>
        <ng-container *ngIf="!actionsRef.innerHTML.trim()">
          <div
            data-test="HNMd-MiY"
            class="row align-items-center gutters-16"
            style="justify-content: end"
          >
            <div data-test="l2XG9sE1" class="col-auto" *ngIf="showCancelButton">
              <button
                data-test="YpuE_HL6"
                class="button button_secondary button_w100"
                (click)="handleCancel()"
                [disabled]="
                  confirmLoaderType && loaderInProgress.includes(confirmLoaderType)
                "
                [mdButtonSpinner]="
                  !!(cancelLoaderType && loaderInProgress.includes(cancelLoaderType))
                "
              >
                {{ cancelBtnText }}
              </button>
            </div>
            <div data-test="EfLVbove" class="col-auto" *ngIf="showConfirmButton">
              <button
                data-test="uEMstCi0"
                class="button button_primary button_w100"
                (click)="confirm.emit()"
                [disabled]="
                  (cancelLoaderType && loaderInProgress.includes(cancelLoaderType)) ||
                  !confirmEnabled
                "
                [mdButtonSpinner]="
                  !!(confirmLoaderType && loaderInProgress.includes(confirmLoaderType))
                "
              >
                {{ confirmBtnText }}
              </button>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </md-wrap-loader>
</ng-template>
